import { DialogContent as MuiDialogContent, SwipeableDrawer as MuiSwipeableDrawer } from '@mui/material'
import { styled } from '@mui/system'
import Typography from '../../atoms/typography/typography'
import Link from '../../molecules/link'
import Button from '../../molecules/button'

const SizeGuideLink = styled(Link)`
	margin-top: 8px;
	cursor: pointer;
	position: absolute;
	top: 0;
	right: 0;
	text-transform: lowercase;
	margin-top: 5px;
	line-height: normal;
	letter-spacing: 1px;
`

const DialogContent = styled(MuiDialogContent)`
	padding: 0;
`

const PriceWrapper = styled('div')`
	padding: ${({ theme }) => theme.spacing(1.75, 0)};
`

const Title = styled(Typography)`
	padding: 0 20px;
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: 0 0 ${({ theme }) => theme.spacing(0.625)} 0;
	}
`

const Subtitle = styled(Typography)`
	color: ${({ theme }) => theme.palette.grey.main};
	padding: 20px;
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(0.625, 0, 5)};
	}
`

const SizeGuideContent = styled('div')`
	padding: ${({ theme }) => theme.spacing(2.5, 0)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(6.5, 0)};
	}

	.Magento-PageBuilder-Tabs {
		.MuiTableCell-root {
			padding: ${({ theme }) => theme.spacing(2, 1)};
			min-width: 47px;
			font-size: var(--font-size-body2);
			color: var(--color-primary);
			border: 1px solid var(--color-grey50);
			text-align: center;

			&:first-of-type {
				padding: ${({ theme }) => theme.spacing(2, 3, 2, 0)};
				border-left: none;
				text-align: left;
			}

			&:nth-child(even) {
				background: var(--color-grey30);
			}

			&:last-of-type {
				border-right: none;
			}
		}

		th.MuiTableCell-root {
			line-height: 24px;
			background: transparent !important;
			border: none;
			font-weight: normal;

			strong {
				font-size: var(--font-size-body1);
				font-weight: 800;
			}
		}

		.MuiTabs-root {
			min-height: 0;
			margin-bottom: ${({ theme }) => theme.spacing(3)};

			.MuiTabs-scroller {
				padding: 0;

				button {
					min-height: 0;
					padding: ${({ theme }) => theme.spacing(1, 2)};
					font-family: var(--font-base-regular);
					font-size: var(--font-size-body2);
					text-transform: lowercase;
					border-bottom: 1px solid var(--color-grey50);
					min-width: 0;

					&:hover {
						background: transparent !important;
					}
				}
			}
		}
	}

	.Magento-PageBuilder-Slider {
		.swiper-button-next,
		.swiper-button-prev {
			display: none;
		}

		${({ theme }) => theme.breakpoints.up('md')} {
			.swiper-button-next,
			.swiper-button-prev {
				display: block;
				position: absolute;
				top: -20px;

				&.swiper-button-prev {
					right: 94px;
					left: auto;
				}

				&.swiper-button-next {
					right: 60px;
				}
			}
		}

		.table-container {
			border: 1px solid var(--color-grey50);
			.header {
				background: var(--color-grey30);
				text-align: left;
				padding: ${({ theme }) => theme.spacing(2)};
				border-bottom: 1px solid var(--color-grey50);

				strong {
					font-size: var(--font-size-body1);
					font-weight: 800;
				}
			}
			.MuiTableCell-root {
				padding: ${({ theme }) => theme.spacing(2)};
				min-width: 0;
				font-size: var(--font-size-body2);
				color: var(--color-primary);
				text-align: right;
				border: none;

				&:first-of-type {
					text-align: left;
				}
			}

			th.MuiTableCell-root {
				background: transparent !important;
				font-weight: normal;
			}

			tr {
				&:hover {
					background: transparent;
				}
			}
		}
	}
`

const ProductName = styled(Typography)``

const SwipeableDrawerStyled = styled(MuiSwipeableDrawer)`
	.MuiPaper-root.MuiDrawer-paper {
		${({ theme }) => theme.scrollbar};
		min-height: calc((var(--vh, 1vh) * 100));
		width: 100%;
		${({ theme }) => theme.breakpoints.up('sm')} {
			max-width: 712px;
			width: 100%;
		}
	}
`

const ButtonClose = styled(Button)`
	color: ${({ theme }) => theme.palette.primary.main};
	margin: 0;
	padding: ${({ theme }) => theme.spacing(0.5)};
	position: absolute;
	top: ${({ theme }) => theme.spacing(1)};
	right: ${({ theme }) => theme.spacing(1)};

	.MuiSvgIcon-root {
		font-size: ${({ theme }) => theme.typography.pxToRem(16)};
	}
`

export {
	DialogContent,
	PriceWrapper,
	SizeGuideLink,
	Subtitle,
	Title,
	ProductName,
	SizeGuideContent,
	SwipeableDrawerStyled,
	ButtonClose,
}
